import React from 'react';
import { Typography } from '@one-thd/sui-atomic-components';
import { shape, string } from 'prop-types';

export const Summary = ({ reviews }) => {
  return (
    <div>
      <Typography variant="body-base" height="tight">{reviews?.summary}</Typography>
    </div>
  );
};

Summary.propTypes = {
  reviews: shape({
    summary: string,
    positiveSummary: string,
    negativeSummary: string
  }).isRequired
};